import { api } from "./api";

export const fetchVapidPublicKey = () =>
  api.get("/push/public-key").then((r) => r.data.public_key);

export const subscribeToPush = (subscription, user_agent) =>
  api.post("/push/subscribe", { ...subscription, user_agent }).then((r) => r.data);

export const unsubscribeFromPush = (endpoint) =>
  api.post("/push/unsubscribe", { endpoint }).then((r) => r.data);

/* ---- Browser helpers ---- */

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getCurrentPushSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function enablePush() {
  if (!pushSupported()) {
    throw new Error("متصفحك لا يدعم إشعارات Push.");
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("لم يُمنح الإذن بإرسال الإشعارات.");
  }

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();

  if (!sub) {
    const publicKey =
      process.env.REACT_APP_VAPID_PUBLIC_KEY || (await fetchVapidPublicKey());
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  const json = sub.toJSON();
  await subscribeToPush(
    { endpoint: json.endpoint, keys: json.keys },
    navigator.userAgent
  );
  return sub;
}

export async function disablePush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try {
      await unsubscribeFromPush(sub.endpoint);
    } catch (_) {
      /* ignore */
    }
    await sub.unsubscribe();
  }
}
